import { type ThunkAction } from "redux-thunk";
import { type RootState } from "~/app/store";
import { type AnyAction } from "~/app/store/types";
import { trackSendToSalesPartnerButton } from "~/app/analytics/ga/ga";

import { type WishlistEntryModel } from "~/features/wishlist/types/model";
import { selectCachedWishlistsMap, selectCachedEntriesMap } from "~/features/wishlist/redux/wishlistSlice";

export function trackShareWishlistThunk(
  salesPartnerName: string,
  wishlistId: string,
): ThunkAction<void, RootState, undefined, AnyAction> {
  return (dispatch, getState) => {
    const state = getState();
    const wishlistsMap = selectCachedWishlistsMap(state);
    const entriesMap = selectCachedEntriesMap(state);
    const wishlist = wishlistsMap[wishlistId];
    const entries =
      wishlist?.entryIds
        .map((id: string) => entriesMap[id])
        .filter((entry): entry is WishlistEntryModel => !!entry)
        .map((entry: WishlistEntryModel) => ({
          designation: state.products.basic[entry.productCode]?.designation ?? "",
          quantity: entry.quantity,
        })) ?? [];

    trackSendToSalesPartnerButton(salesPartnerName, entries, wishlistId);
  };
}
